import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Autocomplete from "@mui/material/Autocomplete";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// SweetAlert2 for notifications
import Swal from "sweetalert2";

import { createScanPermissionApi } from "api/scan";

import { getAllRevendeursApi } from "api/superAdmin";
import { getAllEventApi } from "api/events";

function AjouterScan() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    fromReseller: null,
    selectedEvents: null,
    canScan: false,
  });

  const [revendeurOptions, setRevendeurOptions] = useState([]);
  const [eventOptions, setEventOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const revendeursRes = await getAllRevendeursApi("", "", "", "", 1, 10000);
        const revendeurs = revendeursRes.revendeurs.map((r) => ({
          label: `${r.firstName} ${r.lastName} (${r.email})`,
          id: r._id,
        }));
        setRevendeurOptions(revendeurs);

        const eventsRes = await getAllEventApi();
        const events = eventsRes.items.map((e) => ({
          label: e.eventTitle,
          id: e._id,
        }));
        setEventOptions(events);
      } catch (error) {
        console.error("Failed to fetch data for dropdowns:", error);
      }
    };

    fetchData();
  }, []);

  const handleChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!formData.fromReseller || !formData.selectedEvents) {
      Swal.fire({
        icon: "error",
        title: "err ",
        text: "   err.",
      });
      return;
    }

    setIsLoading(true);
    try {
      const dataToSend = {
        fromReseller: formData.fromReseller.id,
        selectedEvents: formData.selectedEvents.id,
        canScan: formData.canScan,
      };

      await createScanPermissionApi(dataToSend);

      Swal.fire({
        icon: "success",
        title: "succ ",
        text: "sucss!",
      });

      navigate("/scans/voir");
    } catch (error) {
      console.error("Failed to create scan permission:", error);
      Swal.fire({
        icon: "error",
        title: "err",
        text: error.response?.data?.error || "sucss",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Card>
          <MDBox
            variant="gradient"
            bgColor="info"
            borderRadius="lg"
            coloredShadow="info"
            mx={2}
            mt={-3}
            p={3}
            mb={1}
            textAlign="center"
          >
            <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
              ajouter
            </MDTypography>
          </MDBox>
          <MDBox pt={4} pb={3} px={3}>
            <MDBox component="form" role="form" onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <Autocomplete
                    options={revendeurOptions}
                    getOptionLabel={(option) => option.label || ""}
                    value={formData.fromReseller}
                    onChange={(event, newValue) => handleChange("fromReseller", newValue)}
                    renderInput={(params) => (
                      <MDInput {...params} label="(Revendeur)" variant="standard" required />
                    )}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Autocomplete
                    options={eventOptions}
                    getOptionLabel={(option) => option.label || ""}
                    value={formData.selectedEvents}
                    onChange={(event, newValue) => handleChange("selectedEvents", newValue)}
                    renderInput={(params) => (
                      <MDInput {...params} label="evenment " variant="standard" required />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={formData.canScan}
                        onChange={(e) => handleChange("canScan", e.target.checked)}
                      />
                    }
                    label="  (Can Scan)"
                  />
                </Grid>
              </Grid>
              <MDBox mt={4} mb={1}>
                <MDButton
                  variant="gradient"
                  color="info"
                  type="submit"
                  fullWidth
                  disabled={isLoading}
                >
                  {isLoading ? " looding..." : "enreg"}
                </MDButton>
              </MDBox>
            </MDBox>
          </MDBox>
        </Card>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AjouterScan;
